var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    ref: "form",
    attrs: { slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ handleSubmit, invalid }) {
          return [
            _c(
              "form",
              {
                staticClass: "form-horizontal",
                attrs: { role: "form", "data-testid": "NewRingTreeForm" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return handleSubmit(_vm.onSubmit)
                  }
                }
              },
              [
                _c(
                  "fieldset",
                  [
                    _vm.currentRingTree.id
                      ? _c("Field", {
                          attrs: {
                            label: _vm.$t("PING_TREE_ID"),
                            "has-tooltip": false
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-sm-6 col-md-4 p-t-2 p-b-10"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "clipboard",
                                                rawName: "v-clipboard",
                                                value: {
                                                  copyText:
                                                    _vm.currentRingTree.id
                                                },
                                                expression:
                                                  "{ copyText: currentRingTree.id }"
                                              },
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: "Copy",
                                                expression: "'Copy'"
                                              }
                                            ],
                                            staticClass:
                                              "btn btn-link m-l-5 p-0 no_border",
                                            attrs: { placement: "right" }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "typcn typcn-tabs-outline"
                                            })
                                          ]
                                        ),
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(_vm.currentRingTree.id) +
                                            "\n          "
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("PING_TREE_NAME"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("PING_TREE_NAME_TT")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "name",
                                  attrs: { rules: "required", slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xs-6 col-sm-4"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.currentRingTree
                                                            .name,
                                                        expression:
                                                          "currentRingTree.name"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      name: "name",
                                                      autocomplete: "off",
                                                      "custom-autofocus": "true"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.currentRingTree.name
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.currentRingTree,
                                                          "name",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value: "REQUIRED",
                                                    expression: "'REQUIRED'"
                                                  }
                                                ],
                                                staticClass:
                                                  "col-sm-3 col-xs-2 form-group__label-required"
                                              })
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("PING_TREE_TIME_ZONE"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("PING_TREE_TIME_ZONE_TT")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "subId",
                                  attrs: { rules: "required", slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xs-6 col-sm-4"
                                                },
                                                [
                                                  _c("SearchableDropdown", {
                                                    staticClass:
                                                      "rtb-export-timezone m-r-15 m-b-15",
                                                    attrs: {
                                                      config:
                                                        _vm.timeZoneOptions,
                                                      clearable: true,
                                                      "data-testid":
                                                        "timezone-dropdown"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.currentRingTree
                                                          .schedule.timeZoneId,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.currentRingTree
                                                            .schedule,
                                                          "timeZoneId",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "currentRingTree.schedule.timeZoneId"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("label", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value: "REQUIRED",
                                                    expression: "'REQUIRED'"
                                                  }
                                                ],
                                                staticClass:
                                                  "col-sm-3 col-xs-2 form-group__label-required"
                                              })
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("PING_TREE_SET_HOURS"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("PING_TREE_SET_HOURS_TT")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-4 col-sm-2 display-flex flex--align-center"
                                  },
                                  [
                                    _c("NzToggle", {
                                      attrs: { name: "hoursOfOperation" },
                                      model: {
                                        value: _vm.hoursOfOperationEnabled,
                                        callback: function($$v) {
                                          _vm.hoursOfOperationEnabled = $$v
                                        },
                                        expression: "hoursOfOperationEnabled"
                                      }
                                    }),
                                    _vm._v(" "),
                                    !_vm.hoursOfOperationEnabled
                                      ? _c("label", {
                                          directives: [
                                            {
                                              name: "t",
                                              rawName: "v-t",
                                              value:
                                                "PING_TREES_SET_HOURS_STATUS",
                                              expression:
                                                "'PING_TREES_SET_HOURS_STATUS'"
                                            }
                                          ],
                                          staticClass: "m-l-15 m-b-0"
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _vm.hoursOfOperationEnabled
                      ? _c("HoursOfOperation", {
                          attrs: {
                            "initial-hours-of-operation":
                              _vm.computedHoursOfOperation
                          },
                          on: {
                            hoursOfOperation: _vm.updateRingTreeHoursOfOperation
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "legend",
                          {
                            staticClass:
                              "col-lg-offset-1 col-lg-10 display-flex"
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("PING_TREE_REVENUE_SETTINGS_TITLE")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.hover.right",
                                    value: _vm.$t(
                                      "PING_TREE_REVENUE_SETTINGS_TITLE_TT"
                                    ),
                                    expression:
                                      "$t('PING_TREE_REVENUE_SETTINGS_TITLE_TT')",
                                    modifiers: { hover: true, right: true }
                                  }
                                ],
                                staticClass: "m-l-10 f-s-16"
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-question-circle"
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("Field", {
                          attrs: {
                            label: _vm.$t(
                              "PING_TREE_REVENUE_MIN_TO_ROUTE_AMOUNT"
                            ),
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t(
                              "PING_TREE_REVENUE_MIN_TO_ROUTE_AMOUNT_TT"
                            )
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c("ValidationProvider", {
                                      ref: "minRevenueToRoute",
                                      attrs: {
                                        rules: "required|min_value:0",
                                        slim: ""
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ classes, errors }) {
                                              return [
                                                _c("div", { class: classes }, [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-sm-9" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "currency"
                                                        },
                                                        [_vm._v("$")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .currentRingTree
                                                                .minRevenueToRoute,
                                                            expression:
                                                              "currentRingTree.minRevenueToRoute"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control currency input-sm",
                                                        attrs: {
                                                          type: "number",
                                                          step: "0.01",
                                                          "data-testid":
                                                            "currentRingTree.minRevenueToRoute"
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.currentRingTree
                                                              .minRevenueToRoute
                                                        },
                                                        on: {
                                                          wheel: function(
                                                            $event
                                                          ) {
                                                            return $event.target.blur()
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              _vm.currentRingTree,
                                                              "minRevenueToRoute",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      errors[0]
                                                        ? _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "form-group__label-required vv-invalid"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "ERROR_PING_TREE_REVENUE_MIN_TO_ROUTE_AMOUNT_TT"
                                                                  )
                                                                ) +
                                                                  "\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _c("label", {
                                                            directives: [
                                                              {
                                                                name: "t",
                                                                rawName: "v-t",
                                                                value:
                                                                  "REQUIRED",
                                                                expression:
                                                                  "'REQUIRED'"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "m-l-20 form-group__label-required"
                                                          })
                                                    ]
                                                  )
                                                ])
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _vm._v(" "),
                        _c("Field", {
                          staticClass: "m-b-5",
                          attrs: {
                            label: _vm.$t("PING_TREE_REVENUE_TYPE"),
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t("PING_TREE_REVENUE_TYPE_TT")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c("ValidationProvider", {
                                      ref: "revenueTypeSettings",
                                      attrs: { rules: "", slim: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ classes }) {
                                              return [
                                                _c("div", { class: classes }, [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-sm-9" },
                                                    [
                                                      _c("MultipleToggle", {
                                                        attrs: {
                                                          options:
                                                            _vm.revenueTypeOptions,
                                                          value:
                                                            _vm.currentRingTree
                                                              .revenueSettings
                                                              .revenueDynamic
                                                        },
                                                        on: {
                                                          onToggle:
                                                            _vm.onRevenueTypeSettingToggled
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ])
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _vm._v(" "),
                        !_vm.currentRingTree.revenueSettings.revenueDynamic
                          ? _c("Field", {
                              attrs: {
                                label: _vm.$t(
                                  "PING_TREE_STATIC_REVENUE_AMOUNT"
                                ),
                                "has-tooltip": true,
                                "tooltip-text": _vm.$t(
                                  "PING_TREE_STATIC_REVENUE_AMOUNT_TT"
                                )
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "element",
                                    fn: function() {
                                      return [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            rules: "required|min_value:0",
                                            slim: ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ classes }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      { class: classes },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-sm-9"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "currency"
                                                              },
                                                              [_vm._v("$")]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .currentRingTree
                                                                      .revenueSettings
                                                                      .staticRevenueAmount,
                                                                  expression:
                                                                    "currentRingTree.revenueSettings.staticRevenueAmount"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control currency input-sm",
                                                              attrs: {
                                                                type: "number",
                                                                step: "0.01"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .currentRingTree
                                                                    .revenueSettings
                                                                    .staticRevenueAmount
                                                              },
                                                              on: {
                                                                wheel: function(
                                                                  $event
                                                                ) {
                                                                  return $event.target.blur()
                                                                },
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  )
                                                                    return
                                                                  _vm.$set(
                                                                    _vm
                                                                      .currentRingTree
                                                                      .revenueSettings,
                                                                    "staticRevenueAmount",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("label", {
                                                              directives: [
                                                                {
                                                                  name: "t",
                                                                  rawName:
                                                                    "v-t",
                                                                  value:
                                                                    "REQUIRED",
                                                                  expression:
                                                                    "'REQUIRED'"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "m-l-20 form-group__label-required"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("Field", {
                          attrs: {
                            label: _vm.$t(
                              "PING_TREE_REVENUE_ON_FAILURE_AMOUNT"
                            ),
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t(
                              "PING_TREE_REVENUE_ON_FAILURE_AMOUNT"
                            )
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules: "required|min_value:0",
                                        slim: ""
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ classes, errors }) {
                                              return [
                                                _c("div", { class: classes }, [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-sm-9" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "currency"
                                                        },
                                                        [_vm._v("$")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .currentRingTree
                                                                .revenueSettings
                                                                .revenueOnFailure,
                                                            expression:
                                                              "currentRingTree.revenueSettings.revenueOnFailure"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control currency input-sm",
                                                        attrs: {
                                                          type: "number",
                                                          step: "0.01",
                                                          "data-testid":
                                                            "currentRingTree.revenueSettings.revenueOnFailure"
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.currentRingTree
                                                              .revenueSettings
                                                              .revenueOnFailure
                                                        },
                                                        on: {
                                                          wheel: function(
                                                            $event
                                                          ) {
                                                            return $event.target.blur()
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              _vm
                                                                .currentRingTree
                                                                .revenueSettings,
                                                              "revenueOnFailure",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      errors[0]
                                                        ? _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "form-group__label-required vv-invalid"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "ERROR_PING_TREE_REVENUE_ON_FAILURE_AMOUNT"
                                                                  )
                                                                ) +
                                                                  "\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _c("label", {
                                                            directives: [
                                                              {
                                                                name: "t",
                                                                rawName: "v-t",
                                                                value:
                                                                  "REQUIRED",
                                                                expression:
                                                                  "'REQUIRED'"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "m-l-20 form-group__label-required"
                                                          })
                                                    ]
                                                  )
                                                ])
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("Field", {
                                  staticClass: "p-b-0",
                                  attrs: {
                                    label: _vm.$t("PING_TREE_CONVERT"),
                                    "has-tooltip": true,
                                    "tooltip-text": _vm.$t(
                                      "PING_TREE_CONVERT_TT"
                                    )
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "element",
                                        fn: function() {
                                          return [
                                            _c("ValidationProvider", {
                                              ref: "conversionType",
                                              attrs: {
                                                rules: "required",
                                                slim: ""
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ classes }) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          { class: classes },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-xs-4 col-lg-3"
                                                              },
                                                              [
                                                                _c(
                                                                  "SearchableDropdown",
                                                                  {
                                                                    staticClass:
                                                                      "m-r-15 m-b-15",
                                                                    attrs: {
                                                                      config:
                                                                        _vm.revenueConvertOnSettingConfig,
                                                                      clearable: true
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .currentRingTree
                                                                          .revenueSettings
                                                                          .conversionParams
                                                                          .conversionType,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .currentRingTree
                                                                            .revenueSettings
                                                                            .conversionParams,
                                                                          "conversionType",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "\n                          currentRingTree.revenueSettings.conversionParams\n                            .conversionType\n                        "
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("label", {
                                                              directives: [
                                                                {
                                                                  name: "t",
                                                                  rawName:
                                                                    "v-t",
                                                                  value:
                                                                    "REQUIRED",
                                                                  expression:
                                                                    "'REQUIRED'"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "col-sm-3 col-md-3 form-group__label-required"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.currentRingTree.revenueSettings
                              .revenueDynamic &&
                            _vm.computedConversionType === "postBack"
                              ? _c("div", { staticClass: "form-group p-t-0" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-offset-3 col-sm-5" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "bs-callout bs-callout-sm bs-callout-warning m-t-0 m-b-0"
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "PING_TREE_REVENUE_SETTINGS_WARNING_MESSAGE"
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.computedConversionType === "callLength"
                              ? [
                                  _c("Field", {
                                    staticClass: "m-b-5",
                                    attrs: {
                                      label: _vm.$t("PING_TREE_START_EVENT"),
                                      "has-tooltip": true,
                                      "tooltip-text": _vm.$t(
                                        "PING_TREE_START_EVENT_TT"
                                      )
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "element",
                                          fn: function() {
                                            return [
                                              _c("ValidationProvider", {
                                                ref: "startCallLengthOn",
                                                attrs: { rules: "", slim: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function({
                                                        classes
                                                      }) {
                                                        return [
                                                          _c(
                                                            "div",
                                                            { class: classes },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "ol-sm-9 col-md-9"
                                                                },
                                                                [
                                                                  _c(
                                                                    "MultipleToggle",
                                                                    {
                                                                      attrs: {
                                                                        options:
                                                                          _vm.startCallLengthOnOptions,
                                                                        value:
                                                                          _vm
                                                                            .currentRingTree
                                                                            .revenueSettings
                                                                            .conversionParams
                                                                            .conversionArgs
                                                                            .startTimerEvent
                                                                      },
                                                                      on: {
                                                                        onToggle:
                                                                          _vm.startCallLengthOnToggled
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              })
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("Field", {
                                    staticClass: "m-b-5",
                                    attrs: {
                                      label: _vm.$t(
                                        "PING_TREE_TARGET_DYNAMIC_LENGTH"
                                      ),
                                      "has-tooltip": true,
                                      "tooltip-text": _vm.$t(
                                        "PING_TREE_TARGET_DYNAMIC_LENGTH_TT"
                                      )
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "element",
                                          fn: function() {
                                            return [
                                              _c("ValidationProvider", {
                                                ref:
                                                  "conversionCallLengthValue",
                                                attrs: { rules: "", slim: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function({
                                                        classes
                                                      }) {
                                                        return [
                                                          _c(
                                                            "div",
                                                            { class: classes },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "ol-sm-9 col-md-9"
                                                                },
                                                                [
                                                                  _c(
                                                                    "MultipleToggle",
                                                                    {
                                                                      attrs: {
                                                                        options:
                                                                          _vm.conversionCallLengthValueOptions,
                                                                        value:
                                                                          _vm
                                                                            .currentRingTree
                                                                            .revenueSettings
                                                                            .conversionCallLengthDynamic
                                                                      },
                                                                      on: {
                                                                        onToggle:
                                                                          _vm.conversionCallLengthValueToggled
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              })
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  !_vm.currentRingTree.revenueSettings
                                    .conversionCallLengthDynamic
                                    ? _c("Field", {
                                        attrs: {
                                          label: _vm.$t(
                                            "PING_TREE_TARGET_LENGTH"
                                          ),
                                          "has-tooltip": true,
                                          "tooltip-text": _vm.$t(
                                            "PING_TREE_TARGET_LENGTH_TT"
                                          )
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "element",
                                              fn: function() {
                                                return [
                                                  _c("ValidationProvider", {
                                                    attrs: {
                                                      rules: "required",
                                                      slim: ""
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function({
                                                            classes
                                                          }) {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: classes
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "col-sm-2 col-md-1"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                _vm
                                                                                  .currentRingTree
                                                                                  .revenueSettings
                                                                                  .conversionParams
                                                                                  .conversionArgs
                                                                                  .callLengthInSeconds,
                                                                              expression:
                                                                                "currentRingTree.revenueSettings.conversionParams.conversionArgs.callLengthInSeconds"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "form-control input-sm",
                                                                          attrs: {
                                                                            type:
                                                                              "number",
                                                                            step:
                                                                              "0.01"
                                                                          },
                                                                          domProps: {
                                                                            value:
                                                                              _vm
                                                                                .currentRingTree
                                                                                .revenueSettings
                                                                                .conversionParams
                                                                                .conversionArgs
                                                                                .callLengthInSeconds
                                                                          },
                                                                          on: {
                                                                            wheel: function(
                                                                              $event
                                                                            ) {
                                                                              return $event.target.blur()
                                                                            },
                                                                            input: function(
                                                                              $event
                                                                            ) {
                                                                              if (
                                                                                $event
                                                                                  .target
                                                                                  .composing
                                                                              )
                                                                                return
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .currentRingTree
                                                                                  .revenueSettings
                                                                                  .conversionParams
                                                                                  .conversionArgs,
                                                                                "callLengthInSeconds",
                                                                                $event
                                                                                  .target
                                                                                  .value
                                                                              )
                                                                            }
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("label", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "t",
                                                                        rawName:
                                                                          "v-t",
                                                                        value:
                                                                          "REQUIRED",
                                                                        expression:
                                                                          "'REQUIRED'"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "col-sm-3 col-md-3 form-group__label-required"
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  })
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentRingTree.revenueSettings
                                    .conversionCallLengthDynamic
                                    ? _c("Field", {
                                        attrs: {
                                          label: _vm.$t(
                                            "PING_TREE_TARGET_DYNAMIC_MAX_LENGTH"
                                          ),
                                          "has-tooltip": true,
                                          "tooltip-text": _vm.$t(
                                            "PING_TREE_TARGET_DYNAMIC_MAX_LENGTH_TT"
                                          )
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "element",
                                              fn: function() {
                                                return [
                                                  _c("ValidationProvider", {
                                                    attrs: {
                                                      rules: "",
                                                      slim: ""
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function({
                                                            classes
                                                          }) {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: classes
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "col-xs-12 col-sm-6 col-md-3"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                _vm
                                                                                  .currentRingTree
                                                                                  .revenueSettings
                                                                                  .maxConversionCallDurationSeconds,
                                                                              expression:
                                                                                "currentRingTree.revenueSettings.maxConversionCallDurationSeconds"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "form-control m-b-0 input-md",
                                                                          attrs: {
                                                                            type:
                                                                              "number",
                                                                            placeholder:
                                                                              "unlimited"
                                                                          },
                                                                          domProps: {
                                                                            value:
                                                                              _vm
                                                                                .currentRingTree
                                                                                .revenueSettings
                                                                                .maxConversionCallDurationSeconds
                                                                          },
                                                                          on: {
                                                                            wheel: function(
                                                                              $event
                                                                            ) {
                                                                              return $event.target.blur()
                                                                            },
                                                                            input: function(
                                                                              $event
                                                                            ) {
                                                                              if (
                                                                                $event
                                                                                  .target
                                                                                  .composing
                                                                              )
                                                                                return
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .currentRingTree
                                                                                  .revenueSettings,
                                                                                "maxConversionCallDurationSeconds",
                                                                                $event
                                                                                  .target
                                                                                  .value
                                                                              )
                                                                            }
                                                                          }
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "t",
                                                                              rawName:
                                                                                "v-t",
                                                                              value:
                                                                                "SECONDS_TEXT",
                                                                              expression:
                                                                                "'SECONDS_TEXT'"
                                                                            }
                                                                          ]
                                                                        }
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  })
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    : _vm._e()
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "legend",
                          { staticClass: "col-lg-offset-1 col-lg-10" },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("PING_TREE_ERROR_SETTINGS_TITLE"))
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.hover.right",
                                    value: _vm.$t(
                                      "PING_TREE_ERROR_SETTINGS_TITLE_TT"
                                    ),
                                    expression:
                                      "$t('PING_TREE_ERROR_SETTINGS_TITLE_TT')",
                                    modifiers: { hover: true, right: true }
                                  }
                                ],
                                staticClass: "m-l-10 f-s-16"
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-question-circle"
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("Field", {
                          attrs: {
                            label: _vm.$t("PING_TREE_DIAL_TIMEOUT_SECONDS"),
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t(
                              "PING_TREE_DIAL_TIMEOUT_SECONDS_TT"
                            )
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules:
                                          "required|min_value:5|max_value:300",
                                        slim: ""
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ classes, errors }) {
                                              return [
                                                _c("div", { class: classes }, [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-12 col-sm-9 col-md-9"
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .currentRingTree
                                                                .errorSettings
                                                                .dialTimeoutSeconds,
                                                            expression:
                                                              "currentRingTree.errorSettings.dialTimeoutSeconds"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control m-b-0 input-sm",
                                                        attrs: {
                                                          type: "number",
                                                          "data-testid":
                                                            "currentRingTree.errorSettings.dialTimeoutSeconds",
                                                          placeholder: "10"
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.currentRingTree
                                                              .errorSettings
                                                              .dialTimeoutSeconds
                                                        },
                                                        on: {
                                                          wheel: function(
                                                            $event
                                                          ) {
                                                            return $event.target.blur()
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              _vm
                                                                .currentRingTree
                                                                .errorSettings,
                                                              "dialTimeoutSeconds",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        directives: [
                                                          {
                                                            name: "t",
                                                            rawName: "v-t",
                                                            value:
                                                              "SECONDS_TEXT",
                                                            expression:
                                                              "'SECONDS_TEXT'"
                                                          }
                                                        ]
                                                      }),
                                                      _vm._v(" "),
                                                      errors[0]
                                                        ? _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "form-group__label-required vv-invalid"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "ERROR_PING_TREE_DIAL_TIMEOUT_SECONDS"
                                                                  )
                                                                ) +
                                                                  "\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _c("label", {
                                                            directives: [
                                                              {
                                                                name: "t",
                                                                rawName: "v-t",
                                                                value:
                                                                  "REQUIRED",
                                                                expression:
                                                                  "'REQUIRED'"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "m-l-20 form-group__label-required"
                                                          })
                                                    ]
                                                  )
                                                ])
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _vm._v(" "),
                        _c("Field", {
                          attrs: {
                            label: _vm.$t(
                              "PING_TREE_PING_TIMEOUT_MILLISECONDS"
                            ),
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t(
                              "PING_TREE_PING_TIMEOUT_MILLISECONDS_TT"
                            )
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules:
                                          "required|min_value:50|max_value:10000",
                                        slim: ""
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ classes, errors }) {
                                              return [
                                                _c("div", { class: classes }, [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-12 col-sm-9 col-md-9"
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .currentRingTree
                                                                .errorSettings
                                                                .pingTimeoutInMS,
                                                            expression:
                                                              "currentRingTree.errorSettings.pingTimeoutInMS"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control m-b-0 input-sm",
                                                        attrs: {
                                                          type: "number",
                                                          "data-testid":
                                                            "currentRingTree.errorSettings.pingTimeoutInMS",
                                                          placeholder: "2000"
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.currentRingTree
                                                              .errorSettings
                                                              .pingTimeoutInMS
                                                        },
                                                        on: {
                                                          wheel: function(
                                                            $event
                                                          ) {
                                                            return $event.target.blur()
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              _vm
                                                                .currentRingTree
                                                                .errorSettings,
                                                              "pingTimeoutInMS",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        directives: [
                                                          {
                                                            name: "t",
                                                            rawName: "v-t",
                                                            value:
                                                              "MILLISECONDS_TEXT",
                                                            expression:
                                                              "'MILLISECONDS_TEXT'"
                                                          }
                                                        ]
                                                      }),
                                                      _vm._v(" "),
                                                      errors[0]
                                                        ? _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "form-group__label-required vv-invalid"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "ERROR_PING_TREE_PING_TIMEOUT_MILLISECONDS"
                                                                  )
                                                                ) +
                                                                  "\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _c("label", {
                                                            directives: [
                                                              {
                                                                name: "t",
                                                                rawName: "v-t",
                                                                value:
                                                                  "REQUIRED",
                                                                expression:
                                                                  "'REQUIRED'"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "m-l-20 form-group__label-required"
                                                          })
                                                    ]
                                                  )
                                                ])
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _vm._v(" "),
                        _c("Field", {
                          attrs: {
                            label: _vm.$t("PING_TREE_CALL_ON_FAILURE"),
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t(
                              "PING_TREE_CALL_ON_FAILURE_TT"
                            )
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-4 col-sm-2 col-md-2"
                                      },
                                      [
                                        _c("NzToggle", {
                                          attrs: { name: "callOnFailure" },
                                          model: {
                                            value:
                                              _vm.currentRingTree.errorSettings
                                                .callOnFailure,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.currentRingTree
                                                  .errorSettings,
                                                "callOnFailure",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "currentRingTree.errorSettings.callOnFailure"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "legend",
                          { staticClass: "col-lg-offset-1 col-lg-10" },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("PING_TREE_ADD_TARGETS_TITLE"))
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.hover.right",
                                    value: _vm.$t(
                                      "PING_TREE_ADD_TARGETS_TITLE_TT"
                                    ),
                                    expression:
                                      "$t('PING_TREE_ADD_TARGETS_TITLE_TT')",
                                    modifiers: { hover: true, right: true }
                                  }
                                ],
                                staticClass: "m-l-10 f-s-16"
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-question-circle"
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.hasRingTreeTargets
                          ? _c(
                              "div",
                              { staticClass: "col-lg-offset-1 col-lg-10" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "m-t-0 bs-callout bs-callout-warning"
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "PING_TREE_ADD_TARGETS_REQUIRED"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("Field", {
                          attrs: {
                            label: _vm.$t("PING_TREE_SELECT_TARGET"),
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t("PING_TREE_SELECT_TARGET_TT")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "col-xs-4 col-lg-3" },
                                      [
                                        _c("SearchableDropdown", {
                                          staticClass: "m-r-15 m-b-15",
                                          attrs: {
                                            config: _vm.targetsConfig,
                                            clearable: true,
                                            searchable: true,
                                            "data-testid":
                                              "select-target-dropdown"
                                          },
                                          model: {
                                            value: _vm.selectedTarget,
                                            callback: function($$v) {
                                              _vm.selectedTarget = $$v
                                            },
                                            expression: "selectedTarget"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-xs-2 col-sm-3" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-success",
                                            attrs: {
                                              type: "button",
                                              disabled: _vm.targetInCurrentTree,
                                              "data-testid":
                                                "add-target-to-tree"
                                            },
                                            on: { click: _vm.addTargetToTree }
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.$t("PING_TREE_LIST_ADD")
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.hasRingTreeTargets
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "m-t-10 col-md-offset-3 col-md-6 m-b-20"
                          },
                          [
                            _c(
                              "v-table",
                              {
                                staticClass: "table_beauty",
                                attrs: {
                                  data: _vm.currentRingTree.targets,
                                  "hide-sort-icons": true
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "body",
                                      fn: function({ displayData }) {
                                        return _c(
                                          "tbody",
                                          {},
                                          [
                                            _vm._l(displayData, function(
                                              target,
                                              index
                                            ) {
                                              return [
                                                _c("tr", { key: index }, [
                                                  _c("td", [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "table-ellipsis__name linked-name",
                                                        attrs: {
                                                          href: _vm.navigateToTarget(
                                                            target.id
                                                          ),
                                                          target: "_blank",
                                                          title: target.name
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              target.name
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  target.isNumberDynamic
                                                    ? _c("td", [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "PING_TREE_DYNAMIC_TARGET_NUMBER"
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  !target.isNumberDynamic
                                                    ? _c("td", [
                                                        _vm._v(
                                                          "\n                  " +
                                                            _vm._s(
                                                              target
                                                                .instructions
                                                                .number
                                                            ) +
                                                            "\n                "
                                                        )
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c(
                                                      "a",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "tooltip",
                                                            rawName:
                                                              "v-tooltip.right",
                                                            value: _vm.$t(
                                                              "PING_TREE_LIST_DELETE_TT"
                                                            ),
                                                            expression:
                                                              "$t('PING_TREE_LIST_DELETE_TT')",
                                                            modifiers: {
                                                              right: true
                                                            }
                                                          }
                                                        ],
                                                        staticClass:
                                                          "btn btn-list-function",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.deleteTargetFromTree(
                                                              target.id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "typcn typcn-trash"
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    !_vm.isPTTargetFree(target)
                                                      ? _c("i", {
                                                          directives: [
                                                            {
                                                              name: "tooltip",
                                                              rawName:
                                                                "v-tooltip.top",
                                                              value: _vm.$t(
                                                                "PING_TREE_TARGET_DUPLICATED_WARNING"
                                                              ),
                                                              expression:
                                                                "$t('PING_TREE_TARGET_DUPLICATED_WARNING')",
                                                              modifiers: {
                                                                top: true
                                                              }
                                                            }
                                                          ],
                                                          staticClass:
                                                            "f-s-20 p-r-8 typcn bright-red typcn-warning"
                                                        })
                                                      : _vm._e()
                                                  ])
                                                ])
                                              ]
                                            })
                                          ],
                                          2
                                        )
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _c(
                                  "thead",
                                  { attrs: { slot: "head" }, slot: "head" },
                                  [
                                    _c(
                                      "tr",
                                      [
                                        _c("v-th", {
                                          directives: [
                                            {
                                              name: "t",
                                              rawName: "v-t",
                                              value: "PING_TREE_LIST_NAME",
                                              expression:
                                                "'PING_TREE_LIST_NAME'"
                                            }
                                          ],
                                          attrs: { "sort-key": "name" }
                                        }),
                                        _vm._v(" "),
                                        _c("v-th", {
                                          directives: [
                                            {
                                              name: "t",
                                              rawName: "v-t",
                                              value:
                                                "PING_TREE_LIST_DESTINATION",
                                              expression:
                                                "'PING_TREE_LIST_DESTINATION'"
                                            }
                                          ],
                                          attrs: {
                                            "sort-key": "instructions.number"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("th")
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        attrs: { "data-testid": "submit-wrapper" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-sm-8 col-md-8 col-md-offset-3 col-sm-offset-3"
                          },
                          [
                            invalid && _vm.triedToSend
                              ? _c(
                                  "p",
                                  { staticClass: "m-t-8 m-b-8 bright-red" },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "f-s-20 p-r-0 typcn typcn-warning"
                                    }),
                                    _vm._v(
                                      _vm._s(_vm.$t("INVALID_FORM")) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "PrimaryButton",
                              {
                                attrs: {
                                  size: "sm",
                                  "show-loader-on-form": _vm.showLoader,
                                  "data-testid": "submit"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.triedToSend = true
                                  }
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentRingTree.id
                                        ? "UPDATE RING TREE"
                                        : "CREATE RING TREE"
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("button", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "CANCEL",
                                  expression: "'CANCEL'"
                                }
                              ],
                              staticClass: "btn btn-sm btn-danger m-l-15",
                              attrs: { "data-testid": "cancel" },
                              on: { click: _vm.cancel }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }